import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-content-tracking-modal',
  templateUrl: './content-tracking-modal.component.html',
  styleUrls: ['./content-tracking-modal.component.scss']
})
export class ContentTrackingModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

}
